import "./DCAsset.css";
import FileViewer from 'react-file-viewer';
import { DCAssetPreview } from "./DCAssetPreview";

type DCAssetProps = {
    preview?: boolean; 
    title: string;
    url: string;
    onCancel: () => void;
    onSubmit: () => void;
}

export const DCAsset = ({
    preview = false,
    title,
    url,
    onCancel,
    onSubmit
    } : DCAssetProps) => {

    const fileExtension = url.split('.').pop();
    const viewableExtension = fileExtension === "docx" || fileExtension === "pdf";

    return (
        <div className="dc-asset">
            {preview &&
                <DCAssetPreview 
                    title={title}
                    url={url}
                />
            }
            {!preview && viewableExtension && 
                <FileViewer
                    fileType={fileExtension}
                    filePath={url}  // Passing the URL to the file
                />
            }
            {!preview && !viewableExtension &&
                <iframe src={url} />
            }
            
        </div>
    )
}